import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState } from "../";
import { ICrmAccountPlan } from "../../models";
import { AxiosError } from 'axios';
import { ActionTypes } from './action-types';
import { ILookupData } from '.';
import { ActionCreatorsProductCenter, ISaveProductCenterResponse, IProductCenterListResponse, IProductCenterResponse, IProductCenterForListResponse } from './actions-product-center';
import { ActionCreatorsProduct, IProductListResponse, ISaveProductResponse } from './actions-product';

export interface ICrmLookupDataResponse {
    data: {
        success: boolean,
        message: string,
        results: ILookupData
    }
}

export interface ICrmAccountPlanResponse {
    data: {
        success: boolean,
        message: string,
        results: ICrmAccountPlan
    }
}

const ActionCreatorsMain = {
    getCrmLookupData: () => (dispatch: Dispatch<IApplicationState>): Promise<ICrmLookupDataResponse> => {
        var options = {
            url: __API__ + `/crm/lookup-data`
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: ICrmLookupDataResponse) => {
                if (response.data.success)
                    dispatch(ActionCreatorsMain.setLookupData(response.data.results));

                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    setLookupData: (lookupData: ILookupData) => {
        return { type: ActionTypes.SET_CRM_LOOKUP_DATA, lookupData };
    },
    getAccountPlan: (centerId: number) => (dispatch: Dispatch<IApplicationState>): Promise<ICrmAccountPlanResponse> => {
        var options = {
            url: `${__API__}/crm/${centerId}/account-plan`
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: ICrmAccountPlanResponse) => {
                if (response.data.success)
                    dispatch(ActionCreatorsMain.setAccountPlan(response.data.results));

                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    setAccountPlan: (accountPlan: ICrmAccountPlan) => {
        return {
            type: ActionTypes.SET_CRM_ACCOUNT_PLAN,
            accountPlan
        }
    },
    updateCenterNotes: (notes: string) => {
        return {
            type: ActionTypes.UPDATE_CENTER_NOTES,
            notes
        }
    }
}

export const ActionCreators = {
    ...ActionCreatorsMain,
    ...ActionCreatorsProductCenter,
    ...ActionCreatorsProduct,
};

export {
    ISaveProductCenterResponse,
    IProductListResponse, ISaveProductResponse,
    IProductCenterListResponse,
    IProductCenterResponse,
    IProductCenterForListResponse
};